import request from '@/sheep/request';

const EvaluationApi = {
  // 获取测评数据
  getAssessmentData: (params) => request({
    url: '/operation/thirdparty/assessment/data',
    method: 'GET',
    params,
    custom: {
      showLoading: true,
      loadingMsg: '加载测评数据...',
    },
  }),

  // 提交测评答案
  submitAnswers: (data) => request({
    url: '/operation/thirdparty/assessment/answer/save',
    method: 'POST',
    data,
    custom: {
      showLoading: true,
      loadingMsg: '提交中...',
    },
  }),

  // 暂存答案（如果后端有单独接口）
  saveProgress: (data) => request({
    url: '/operation/evaluation/save',
    method: 'POST',
    data,
    custom: {
      showLoading: false,
      showError: false,
    },
  }),
  // 拿到报告
  getReport: (params) => request({
    url: '/operation/thirdparty/assessment/report/url',
    method: 'GET',
    params,
    custom: {
      showLoading: true,
      loadingMsg: '加载报告...',
    },
  }),
  /**
   * 获取所有报告列表
   * @returns
   */
  getReportAll: () => request({
    url: '/operation/thirdparty/assessment/report/report-all',
    method: 'GET',
    custom: {
      showLoading: true,
      loadingMsg: '加载报告...',
    },
  }),

};

export default EvaluationApi;